import * as React from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { useTranslation } from "react-i18next";
import AppInformation from '../AppInformation';
import GeneralSettings from './GeneralSettings';
import CashbackSettings from './CashbackSettings';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


console.log(process.env)

export default function Settings() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          aria-label="settings tabs"
          onChange={(_, newValue) => {
            setValue(newValue);
          }}
        >
          <Tab style={{ marginRight: "20px" }} label={t('app_info')} {...a11yProps(0)} />
          <Tab style={{ marginRight: "20px" }} label={t('general_settings')} {...a11yProps(1)} />

          {process.env.REACT_APP_ENABLE_BOOKING_CASHBACK == 'true' &&
            <Tab style={{ marginRight: "20px" }} label={t('CASHBACK_SETTINGS')} {...a11yProps(2)} />
          }
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AppInformation />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GeneralSettings />
      </TabPanel>

      {process.env.REACT_APP_ENABLE_BOOKING_CASHBACK == 'true' &&
        <TabPanel value={value} index={2}>
          <CashbackSettings />
        </TabPanel>
      }
    </Box>
  );
}